import {$} from '../utils';

// Project Overview marquee component
const ProjectOverViewMarquee = () => {
    // Getting the element
    const element = document.getElementById('overviewSlideMarquee');

    // Return if element not exist
    if (!element) return;

    // Getting window width
    const windowWidth = window.outerWidth;
    // Get element width
    const scrollWidth = element.scrollWidth;
    // Offset
    const offset = scrollWidth - windowWidth;
    // Getting current left
    let left = 0;
    let movement = 'backward';

    setInterval(() => {

        if (movement === "backward") {
            if (left > -(offset)) {
                left--;
            } else {
                movement = "forward";
            }
        }

        if (movement === "forward") {
            if (left < 0) {
                left++;
            } else {
                movement = 'backward';
            }
        }
        element.style.left = left + 'px';
    }, 12);

};

// Export component
export default ProjectOverViewMarquee;